import React from "react";
import { invertVideo } from "./video";

class InvertButton extends React.Component {
  render() {
    return (
      <button
        onClick={function() {
          invertVideo();
        }}
      >
        Invert
      </button>
    );
  }
}

export { InvertButton };
